import { useEffect, useState } from 'react';
import './App.css';
import { Button, Loader, Text, ThemeProvider } from 'monday-ui-react-core';
import FormLogin from './components/security/FormLogin';
import FormDashboard from './components/FormDashboard';
import MainService from './services/MainService';
import FormCreatePassword from './components/security/FormCreatePassword';
import UrlConsts from './constants/UrlConstants';
import PermissionDenied from './components/PermissionDenied';

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [isLogin, setIsLogin] = useState(false);
  const [isSetupUsingPass, setIsSetupUsingPass] = useState<number>(); //0: no authen, 1: authen, 9: need to setup
  const [context, setContext] = useState<any>();
  const [createdPass, setCreatedPass] = useState(false);
  const [isRequestResetPassword, setIsRequestResetPassword] =
    useState<boolean>(false);
  const [isApprovedResetPassword, setIsApprovedResetPassword] =
    useState<boolean>(false);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const tmpContext = await MainService.getContext();
      setContext(tmpContext);
    }

    fetchData();
  }, []);

  useEffect(() => {
    if (context) {
      // context updated, call checkAuthenType
      const checkAuthenTypeAsync = async () => {
        await checkAuthenType();

        setIsLoading(false);
      };

      checkAuthenTypeAsync();
    }
  }, [context]); // add context to useEffect's dependency array

  async function checkAuthenType() {
    // const { usingPass, requestReset, approvalRequest, viewMode, greyDefault, passCreated, token }
    // const dataSC = await MainService.get({}, UrlConsts.scForm);
    // MainService.csrf = dataSC.csrfToken;
    const rs = await MainService.postNoAuthen(
      {
        accountId: context?.account?.id,
        boardId: context?.boardId,
      },
      UrlConsts.checkAuthenType
    );
    const data = rs?.data;
    if (data?.usingPass === 0) MainService.setToken(data?.token);
    setIsSetupUsingPass(data?.usingPass); // 0: no authen, 1: authen, 9: need to setup
    context.isUsingPassword = data?.usingPass === 1;
    context.viewMode = data?.viewMode;
    context.greyDefault = data?.greyDefault;
    context.passCreated = data?.passCreated;
    setCreatedPass(data?.passCreated);
    context.isOwner = context.owners?.some((s) => s.id === context.user.id);
    if (context.isOwner) {
      const _approvalRequest = context.isOwner ? data?.approvalRequest : false;
      setIsApprovedResetPassword(_approvalRequest);
      setIsRequestResetPassword(data?.requestReset);
    }
  }

  async function handleCreatePassComplete() {
    setIsApprovedResetPassword(false);
    setIsRequestResetPassword(false);
    context.isUsingPassword = true;
    context.passCreated = true;
    setCreatedPass(true);
  }

  async function handleReset(approve) {
    const data = {
      accountId: context?.account?.id,
      boardId: context?.boardId,
      approve,
    };
    setIsApprovedResetPassword(approve);
    setIsRequestResetPassword(approve);
    await MainService.post(data, UrlConsts.approveRejectResetPassword);
    MainService.notice(approve ? "Approved" : "Rejected");
  }

  async function handleLogin(authen: boolean) {
    setIsLogin(authen);
    setIsLoading(false);
  }

  async function handleLoadChange(loading: boolean) {
    setIsLoading(loading); // Update isLoading based on loading state from FormMandatory
  }

  return (
    <ThemeProvider
      systemTheme={context?.theme}
      themeConfig={context?.themeConfig}
    >
      <div className="App">
        <div className="max-w-7xl mx-auto main-form">
          {isLoading && (
            <div className="inline-block mt-16">
              <Loader
                className="custom-loader-form"
                hasBackground={true}
                size={64}
              />
            </div>
          )}
          {context?.user?.isViewOnly ? (
            <PermissionDenied></PermissionDenied>
          ) : !isRequestResetPassword && !isApprovedResetPassword ? (
            !createdPass ? (
              isSetupUsingPass === 0 ? (
                <FormDashboard
                  context={context}
                  onLoadChange={handleLoadChange}
                ></FormDashboard>
              ) : isSetupUsingPass === 1 ? (
                <div className="mt-4 max-w-md m-auto">
                  <FormCreatePassword
                    context={context}
                    createPassComplete={handleCreatePassComplete}
                  ></FormCreatePassword>
                </div>
              ) : null
            ) : !isLogin ? (
              <FormLogin context={context} onLogin={handleLogin}></FormLogin>
            ) : (
              <FormDashboard
                context={context}
                onLoadChange={handleLoadChange}
              ></FormDashboard>
            )
          ) : !isApprovedResetPassword ? (
            <div className="mt-4 max-w-md m-auto">
              <div className="mb-5">
                <Text
                  type={Text.types.TEXT2}
                  color={Text.colors.PRIMARY}
                  ellipsis={false}
                  className="text-lg"
                >
                  Once the reset password request has been approved, board owner
                  can change the password
                </Text>
              </div>
              <div>
                <Button
                  onClick={() => {
                    handleReset(false);
                  }}
                  className="text-center mr-5"
                  color={Button.colors.NEGATIVE}
                >
                  Reject
                </Button>
                <Button
                  onClick={() => {
                    handleReset(true);
                  }}
                  className="text-center"
                >
                  Approve
                </Button>
              </div>
            </div>
          ) : (
            <div className="mt-4 max-w-md m-auto">
              <FormCreatePassword
                context={context}
                createPassComplete={handleCreatePassComplete}
              ></FormCreatePassword>
            </div>
          )}
        </div>
      </div>
    </ThemeProvider>
  );
}

export default App;
